import React, { PropTypes } from "react";
import Menu from "../Menu";
import MenuItem from "../MenuItem";
import classnames from 'classnames';
import styles from './styles.scss';

function StageComparison({ children }) {
  return (


    <div className="slds-grid slds-gutters" style={{ height: "100%" }}>
      <div className="slds-col slds-border_right">
        <div className="slds-text-title_caps">Before:</div>

        <div className={classnames(
            styles.stage,
            "slds-align_absolute-center"
          )}>
          <Menu comparison="before">
            <MenuItem key="Button 1" label="Button 1" />
            <MenuItem key="Button 2" label="Button 2" />
            <MenuItem key="Button 3" label="Button 3" />
            <MenuItem key="Button 4" label="Button 4" />
            <MenuItem key="Button 5" label="Button 5" />
          </Menu>
        </div>
      </div>
      <div className="slds-col">
      <div className="slds-text-title_caps">After:</div>
        <div className={classnames(
          styles.stage,
          "slds-align_absolute-center"
          )}>
          <Menu comparison="after">
            <MenuItem key="Button 1" label="Button 1" />
            <MenuItem key="Button 2" label="Button 2" />
            <MenuItem key="Button 3" label="Button 3" />
            <MenuItem key="Button 4" label="Button 4" />
            <MenuItem key="Button 5" label="Button 5" />
          </Menu>
        </div>
      </div>
    </div>
  );
}

export default StageComparison;


// WEBPACK FOOTER //
// ./src/components/StageComparison/index.js